export default {
  login: "api/login",
};
